import $ from "jquery";
export default function telEmail() {
    $('.avu-tel-email-links-button').on('click', function() {
        $(this).siblings('.avu-tel-email-links-container').toggleClass('show');
    });
}